import React from 'react';
import $ from "jquery";
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { TextArea, Form, Dropdown, Button } from 'semantic-ui-react';

import Title from '../../title';
import Remarks from './remarks';
import Voucher from './voucher';
import Loading from '../../loadings';
import Changemode from './changemode';
import Transfer from '../Journal/transfer';
import Server from '../../../functions/server';
import CanceledInvoice from './canceledreceipt';
import getFormatedDate from '../../../functions/date';
import Genaratereceiptpdf from './genaratereceiptpdf';
import Permission from '../../../functions/permission';
import ReadCookie from '../../../functions/readcookies';
import MakeDecimalPoints from '../../makedecimalpoints';
import CustomerDropdown from '../../dropdown/customerdropdown';
import Getstatement from '../../Sales/CustomerStatement/getstatement';
import ChangeReceiptDate from './changereceiptdate';

export default class Receipt extends React.Component {

  state = {
    load: false, message: '', statusfilter: 'All', selectedCustomer: '', pageNumber: 0, orderElement: 'date',
    sortingOrder: 'DESC', selectedMode: 'All', allTractions: [], totalPages: 10, paymentmode: [], modeOption: [],
    from_date: getFormatedDate(new Date(), 'fromDate'), statusOption: [], menuPermission: [],
    to_date: getFormatedDate(new Date(), 'toDate'), selectedValue: 'All'
  }

  componentDidMount() {
    let menuPermission = Permission('receipt', this.props.menus);
    if (menuPermission.view) {
      this.checkBranch();
      this.getTranscation(0);
      this.getStatus();
    }
    this.setState({ menuPermission })
  }

  getTranscation(pageNumber) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let { 
      from_date, statusfilter, selectedCustomer, selectedValue, 
      orderElement, sortingOrder, selectedMode, to_date,  
    } = this.state;
    let data = { 'mode': selectedMode, 'cid': selectedCustomer, 'statusfilter': statusfilter, 'page': pageNumber, selectedValue,
    'orderElement': orderElement, 'sortingOrder': sortingOrder, 'fromDate': from_date, 'toDate': to_date, 'eid': cook.id };
    context.setState({ load: true, message: 'Getting Transactions!!!', pageNumber })
    $.ajax({
      type: 'POST', data,
      url: Server() + 'receipt/get.php',
      success: function(allTractions) {
        let totalPages = 0;
        try {
          allTractions = JSON.parse(allTractions);
          for (var i = 0; i < allTractions.length; i++) {
            totalPages = allTractions[i].totalPage;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({ allTractions, totalPages: roundOff, load: false })
        } catch (error) {
          alert(error)
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  checkBranch() {
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    this.getTransactionmode(branchId);
  }

  getStatus() {
    let context = this;
    $.ajax({
      type: 'POST', data: { },
      url: Server() + 'receipt/getstatus.php',
      success: function(data) {
        var status = [];
        context.setState({  });
        try {
          data = JSON.parse(data);
          status.push({ key: 'All', text: 'All', value: 'All' })
          data.map((y) => { status.push({key: y.status, text: y.status, value: y.status}); });
          context.setState({ status: data, statusOption: status });
        } catch (e) {
        }
      },
      error: function(e) {
        alert('Try again!!')
      }
    });
  }

  getTransactionmode(branchId) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'executiveid': userId, branchId },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data) {
        try {
          data = JSON.parse(data); var mode = [];
          mode.push({ key: 'All', text: 'All', value: 'All' })
          data.map((y) => { mode.push({key: y.mode, text: y.mode, value: y.mode}); });
          context.setState({ allModes: data, modeOption: mode, selectedMode: 'All', paymentmode: data, branchId });
        } catch (e) {
        }
      },
      error: function(e) {
        alert('Try again!!')
      }
    });
  }

  mode = (f, { value }) => this.setState({ selectedMode: value })

  menu = (f, { value }) => this.setState({ selectedValue: value })

  handlePaginationChange = (e, { activePage }) => this.getTranscation(activePage);

  handleChange = name => event => this.setState({ [name]: event.target.value })

  status = (f, { value }) => this.setState({ 'statusfilter': value })

  openStatementDialog() {
    if (this.state.selectedCustomer == '' || this.state.selectedCustomer == undefined || this.state.selectedCustomer == null) {
      alert('Select Customer!!!'); return;
    }
    this.setState({ open: true })
  }

  saveSelectedCustomer(selectedCustomer, allCustomer) {
    let selectedCustomerName = '';
    allCustomer.map((x) => {
      if (x.id == selectedCustomer) {
        selectedCustomerName = x.name;
      }
    })
    this.setState({ selectedCustomerName, selectedCustomer, allCustomer })
  }

  handleChange1 = name => event => {
    this.setState({ [name]: event.target.value })
  }

  cancelConformed() {
    let context = this;
    context.setState({ load: true, message: 'cancelling receipt!!!' })
    $.ajax({
      type: 'POST', data: { 'id': context.state.cancelId, 'reason': this.state.reason },
      url: Server() + 'receipt/cancelreceipt.php',
      success: function(data) {
        context.setState({ load: false })
        let x = [];
        if (data == 1) {
          context.state.allTractions.map((c) => {
            if (c.id == context.state.cancelId) {
            }
            else { x.push(c); }
          })
          context.setState({ openConform: false, cancelId: '', allTractions: x })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let { openDrawer } = this.props;
    let { load, message, allTractions, totalPages, pageNumber, paymentmode, menuPermission, 
      from_date, to_date, modeOption, selectedMode, statusOption } = this.state;
    let sino = (pageNumber * 100);
    let menuOption = [
      { key: 'All', text: 'All', value: 'All' },
      { key: 'App', text: 'App', value: 'App' },
      { key: 'Web', text: 'Web', value: 'Web' }
    ]
    return (
      <div>
        <Title title={'Receipt'} openDrawer={openDrawer} />
        <Loading load={load} message={message} />
        <div style={{margin: '0.5%'}}>
          <div style={{display: 'flex'}}>
            <div>
              From Date<br/>
              <input type="date" id="date" value={from_date}
                onChange={this.handleChange('from_date')} />
            </div>
            <div style={{marginLeft: 2}}>
              To Date<br/>
              <input type="date" id="date" value={to_date}
                onChange={this.handleChange('to_date')} />
            </div>
            <div style={{marginLeft: 2, marginTop: 8}}>
              <Dropdown placeholder={'Payment Mode'} onChange={this.mode} selection options={modeOption} value={selectedMode} />
            </div>
            <div style={{marginLeft: 2, marginTop: 8}}>
              <Dropdown style={{width: '50px'}} placeholder='Receipt From' onChange={this.menu} selection options={menuOption} 
              value={this.state.selectedValue} />
            </div>
            <div style={{marginLeft: 2, marginTop: 8}}>
              <Dropdown style={{width: '100px'}} onChange={this.status} selection options={statusOption}
                value={this.state.statusfilter} placeholder='Status' />
            </div> 
            <div style={{marginLeft: 5, marginTop: 8}}>
              <Button color='primary' variant='outlined' onClick={this.getTranscation.bind(this, 1)}>Submit</Button>
            </div>  
            <div style={{marginLeft: 5, marginTop: 8}}>
              <CanceledInvoice name={'Cancelled Receipt'} type="Receipt" />
            </div>
            <div style={{marginLeft: 5, marginTop: 8}}>
              { this.state.menuPermission.add ?
                (<Transfer type="Customer" transferControl={this.state.transferControl}  />):''
              }
            </div>
          </div>
          <div style={{display: 'flex'}}>
            <div style={{marginLeft: 2, width: '15%'}}>
              Selected Customer<br/>
              <CustomerDropdown ref={instance => { this.child = instance; }} update={this.saveSelectedCustomer.bind(this)} /><br/>
            </div>
            <div style={{marginLeft: 5, marginTop: 8}}>
              <Button primary onClick={this.openStatementDialog.bind(this)}>STMT</Button>
            </div>
            
          </div>
          <Paper>
            <div id="scrolls">
              <table id="table" width="100%">
                <tr>
                  <th id="tableheader">Sino</th>
                  <th id="tableheader">Id</th>
                  <th id="tableheader">Receipt Voucher</th>
                  <th id="tableheader">Receipt Date</th>
                  <th id="tableheader">Created Date</th>
                  <th id="tableheader">Customer</th>
                  <th id="tableheader">Amount</th>
                  <th id="tableheader">Mode</th>
                  <th id="tableheader">Status</th>
                  <th id="tableheader">Voucher</th>
                  <th id="tableheader">Remarks</th>
                  <th id="tableheader">Cancel</th>
                </tr>
                { 
                  allTractions.map((x) => {
                    let remark = x.remarks;
                    let amount = x.amount;
                    let createdDate = x.timestamp.split(' ')[0];
                    try {
                      if (remark.length >= 10) { remark = remark.substring(0, 10)+'.....'; }
                      amount = Number(amount);
                    } catch (e) {
                    }
                    return (
                      <tr id='tbody'>
                        <td>{++sino}</td>
                        <td>{x.id}</td>
                        <td>
                          <Genaratereceiptpdf id={x.id} receiptVoucher={x.receipt_voucher} />
                        </td>
                        <td><ChangeReceiptDate item={x} updateData={this.getTranscation.bind(this, this.state.pageNumber)} /></td>
                        <td>{createdDate.split('-')[2]+"-"+createdDate.split('-')[1]+"-"+createdDate.split('-')[0]}</td>
                        <td>{x.cid+'->'+x.name}</td>
                        <td>{"Rs."+x.amount}</td>
                        <td>
                          <Changemode menuPermission={menuPermission} mode={x.mode} 
                            paymentmode={paymentmode}
                            id={x.id} data={allTractions} updateData={this.getTranscation.bind(this)} />
                        </td>
                        <td>{x.status}</td>
                        <td>
                          <Voucher id={x.id} voucher={x.voucher}
                            updateData={this.getTranscation.bind(this)} data={allTractions} />
                        </td>
                        <td><Remarks remark={remark} fullremarks={x.remarks} /></td>
                        { this.state.menuPermission.cancel ?
                          <td onClick={ () => { this.setState({ openConform: true, cancelId: x.id }) }}>
                            Cancel
                          </td> :
                          ''
                        }
                      </tr>
                    )
                  })
                }
              </table>
            </div>
            {/* <div align="right">
              <Pagination activePage={pageNumber} boundaryRange={1}
                onPageChange={this.handlePaginationChange} siblingRange={1}
                totalPages={totalPages} />
            </div> */}
          </Paper>
        </div>
        <Dialog fullWidth={true}
          maxWidth={'lg'}  open={this.state.open}
          onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Detailed Statement</DialogTitle>
          <DialogContent>
            <Getstatement menuPermission={this.state.menuPermission} fromDate={this.state.from_date} toDate={this.state.to_date} id={this.state.selectedCustomer} customername={this.state.selectedCustomerName} getClosingbalance={this.state.getClosingbalance} />
          </DialogContent>
        </Dialog>

        <Dialog fullWidth={true}
          maxWidth={'sm'}  open={this.state.openConform}
          onClose={ () => { this.setState({ openConform: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Are You Conform to Cancel this Receipt!!!!</DialogTitle>
          <DialogContent>
            Reason<br/>
            <Form>
              <TextArea value={this.state.remark} onChange={this.handleChange1('reason')} fluid />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button color='primary' variant='outlined' onClick={ () => { this.setState({ openConform: false }) }}>Close</Button>
            <Button color='primary' variant='outlined' onClick={this.cancelConformed.bind(this)}>Submit</Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }

}